import React from 'react'
import FormDialog from '../../../../library/form/components/FormDialog';
import withView from '../../../cmn/docAutomation/withView';
import FormTitle from '../../../../library/form/components/FormTitle';
import {CmnMetalSearch} from '../../../cmn/snippet/Index';
import BomCMNItemEditor from './BomCMNItemEditor';
import { UiGridColOne, UiCol } from "../../../../library/layout/Index";

const BomMetalEditor = (props) => {
    const { formObject, viewData, masterKeys, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '350px' }}
            formStyle={{ width: '400px' }} formTitle={<FormTitle formObject={formObject} masterKeys={masterKeys} value="Metal Editor" />}
        >
            <UiGridColOne>
                <UiCol>
                    <ul>
                        <li>
                            <CmnMetalSearch formObject={formObject} rowKey="" viewData={viewData} masterKeys={masterKeys} {...restProps} />
                        </li>
                        <BomCMNItemEditor {...props} />
                    </ul>
                </UiCol>
            </UiGridColOne>
        </FormDialog>
    )
}

export default withView(BomMetalEditor, "bomItem", "bomItem")